import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

/*---------------------------------------
    vars
---------------------------------------*/
const { body } = document;

/*---------------------------------------
    DOMContentLoaded
---------------------------------------*/
document.addEventListener(
    'DOMContentLoaded',
    function() {
        toggleMenuInit();
        stickyHeaderInit();
        testimonySliderInit();
    },
    false,
);

/*---------------------------------------
    toggle menu
---------------------------------------*/
function toggleMenuInit() {
    const hamburger = document.querySelector('.js-menu-toggle');
    hamburger.addEventListener('click', function() {
        body.classList.toggle('is-menuopen');
    });
}

function stickyHeaderInit() {
    const stickyHeader = document.querySelector('.js-sticky-header');
    window.addEventListener('scroll', function() {
        if (window.pageYOffset > 82) {
            stickyHeader.classList.add('is-headerstuck');
        } else {
            stickyHeader.classList.remove('is-headerstuck');
        }
    });
}

/*---------------------------------------
    Home page slider
---------------------------------------*/
function testimonySliderInit() {
    const testimonySlider = document.querySelector('.js-testimonials');
    if (testimonySlider) {
        /* eslint-disable no-unused-vars */
        const homeSlider = new Swiper(testimonySlider, {
            loop: false,
            speed: 600,
            autoHeight: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            // autoplay: {
            //     delay: 10000,
            //     disableOnInteraction: false,
            // },
            navigation: {
                prevEl: '.js-testimonials-prev',
                nextEl: '.js-testimonials-next',
            },
        });
    }
}
